import { X, ImageIcon, Video } from "lucide-react";

const FilePreview = ({ files, onRemoveFile, onFileClick }) => {
  if (files.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 w-full p-2 bg-muted/30 rounded-lg">
      {files.map((file, idx) => {
        const isImage = file.type.startsWith("image/");
        const isVideo = file.type.startsWith("video/");
        const previewUrl = URL.createObjectURL(file);

        return (
          <div key={idx} className="relative group">
            <div
              className="w-10 h-10 rounded-full overflow-hidden border-2 border-gray-200 shadow-sm bg-white cursor-pointer"
              onClick={() =>
                onFileClick({ file, previewUrl, isImage, isVideo })
              }
            >
              {isImage && (
                <img
                  src={previewUrl}
                  alt="preview"
                  className="w-full h-full object-cover"
                />
              )}
              {isVideo && (
                <div className="w-full h-full bg-gray-100 flex items-center justify-center relative">
                  <video
                    src={previewUrl}
                    className="w-full h-full object-cover"
                    muted
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
                    <Video className="w-6 h-6 text-white" />
                  </div>
                </div>
              )}
            </div>

            <button
              type="button"
              className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-200"
              onClick={() => {
                onRemoveFile(idx);
                URL.revokeObjectURL(previewUrl);
              }}
            >
              <X className="w-3 h-3" />
            </button>

            <div className="absolute bottom-0 right-0 bg-black bg-opacity-50 text-white text-xs px-1 rounded-tl">
              {isImage ? (
                <ImageIcon className="w-3 h-3" />
              ) : (
                <Video className="w-3 h-3" />
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FilePreview;
